// /profile — профиль: роли и замещения, смена пароля, сеансы. Право — свой профиль (сам).
import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '../../../features/profile/ProfilePage.tsx';

export const Route = createFileRoute('/_app/_settings/profile')({
  staticData: { crumb: 'Профиль' },
  component: ProfilePage,
});
